import { useQueryClient } from 'react-query'

import { GetProfileResponse } from '@cash-web/protos/squareup/franklin/app/profile.pb'
import { useMutationLinkBankAccount } from '@cash-web/shared-data-access-api/react-query/useMutationLinkBankAccount'
import { useQueryGetProfile } from '@cash-web/shared-data-access-api/react-query/useQueryGetProfile'

import { updateInstruments } from './instrumentsUtil'

export const useOptimisticMutationLinkBank = (params: Parameters<typeof useMutationLinkBankAccount>[0]) => {
  const queryClient = useQueryClient()

  return useMutationLinkBankAccount({
    ...params,
    mutationOptions: {
      onSuccess: response => {
        const instrument = response.instrument
        const token = instrument?.token

        if (token === undefined || instrument === undefined) {
          return
        }

        queryClient.setQueryData<GetProfileResponse | undefined>(useQueryGetProfile.rootQueryKey, response => {
          if (response === undefined) {
            return undefined
          }

          const res = {
            ...response,
            profile: {
              ...response.profile,
              instruments: updateInstruments({
                instruments: response.profile?.instruments ?? [],
                newInstrument: { ...instrument, token },
              }),
            },
          }

          return res
        })
      },
    },
  })
}
